// extracted by mini-css-extract-plugin
export default {"expandable":"Expandable_expandable__fXoV3","title":"Expandable_title__Q31LK","arrow":"Expandable_arrow__fIPbE","content":"Expandable_content__iWqkH"};